import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/public`;

const headers = { 
  'Content-Type': 'multipart/form-data',
 
};

const publicApi = {

 
  getDateTimeAddDay2: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/getDateTimeAddDay?AddDay=` + params;
    console.log("url==========", url);
    return ServiceApi.get(url, { params });
  },
  getDateTimeAddDay: (params) => {
    const url = `${baseServiceUrl}/getDateTimeAddDay`;
    return ServiceApi.get(url,  {params} );
  },
  getEnumValues: (params) => {
    const url = `${baseServiceUrl}/getEnumValues`;
    return ServiceApi.get(url,  {params} );
  },
};

export default publicApi;


